import { Agency } from './agencyService';
import apiClient from './apiClient';
import { Currency } from './packService';

export interface Country {
  id: number;
  name: string;
  code: string;
  flag?: string;
}

export interface Transaction {
  id: number;
  amount: number;
  currency: Currency;
  status: string;
  type: string;
  subscriberId: number;
  agency: Agency;
  createdAt: Date;
  description?: string;
  transactionType?: string;
  transactionDateTime?: string;
  userCountry?: Country;
  destinationCountry?: Country;
  packId?: number;
  packName?: string;
}

export type DateFilter = 'day' | 'week' | 'month' | 'year' | 'all';

export interface TransactionFilter {
  dateFilter?: DateFilter;
  startDate?: string;
  endDate?: string;
  country?: string;
  status?: string;
  type?: string;
}

export const transactionService = {
  getAll: () => 
    apiClient.get('/transactions?page=0&size=9999'),

  // Pour l'admin: récupérer les transactions d'un abonné spécifique
  getBySubscriber: (subscriberId: number) =>
    apiClient.get(`/v1/transactions/subscriber/${subscriberId}`),

  getByAgency: (agencyId: number) =>
    apiClient.get(`/transactions/agency/${agencyId}`),

  getFiltered: (filters: TransactionFilter) =>
    apiClient.get('/transactions/filtered', { params: filters }),

  getByDateRange: (startDate: string, endDate: string) =>
    apiClient.get(`/transactions/date-range?start=${startDate}&end=${endDate}`),

  getByDateFilter: (dateFilter: DateFilter) =>
    apiClient.get(`/transactions/filter/${dateFilter}`),

  create: (transaction: Omit<Transaction, 'id'>) =>
    apiClient.post('/transactions', transaction),

  updateStatus: (id: number, status: string) =>
    apiClient.patch(`/transactions/${id}/status`, { status })
};